package com.evoapps.evoshift.ui.reports

/** A file the app made for the person to keep or send on (e.g. the hours for the accountant). */
class ExportFile(val name: String, val mimeType: String, val text: String)

/**
 * Hands an [ExportFile] to the person: the web downloads it, Android asks "Save as…" (the
 * system's folder and name) or "Share" (Drive, mail it to the accountant; SH-161 F4), the desktop
 * opens its Save dialog, iOS the share sheet. Bound per platform in platformModule; UI tests bind
 * a recorder.
 */
fun interface FileSaver {
    fun save(file: ExportFile)
}

/**
 * SH-161 F4: where the platform asks how an export goes on (Android: "Save as…" or "Share", in
 * the window it came from). Hosted once per window by App.kt; nothing elsewhere, whose
 * [FileSaver] needs no question (the web downloads, the desktop's Save dialog, iOS's share sheet).
 */
@androidx.compose.runtime.Composable
expect fun ExportChoiceHost()
